import styled from "styled-components";
import Form from "@/common/components/form/Form";
import { ClipSpinner } from "@/common/components/spinner";
import { PageContainr } from "@/common/elements";
import { KeyValueObj } from "@/common/types";

import { registerInvitedInput } from "./data";
import { COMPLETE_DRF_INVITATION_URL } from "@/common/constants";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useNotification } from "@/common/components/Notifications/NotificationProvider";
import { useApiCallHandling } from "@/hooks/useApiCallHandling";
import { useState } from "react";

const InvitedWrapper = styled(PageContainr)`
  width: 100%;

  .top {
    width: 100%;
    margin-top: 2rem;

    .logo-wrapper {
      width: 60px;
    }

    .welcome-message {
      margin-left: 1.75rem;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      .sign-up {
        font-weight: 500;
        font-size: 3rem;
        line-height: 3.875rem;
        letter-spacing: 0.0009rem;
        font-family: "DM Sans";
        color: ${({ theme }) => theme.bg.primary};

        @media (max-width: ${({ theme }) => theme.screen.smallScreen}) {
          font-size: 2.2rem;
        }
      }
    }
  }

  .form {
    width: 100%;
    max-width: 76rem;
    margin-bottom: 2.25rem;
    margin-top: 1rem;
  }
`;

export interface IRegisterInvitedProps {}

export function RegisterInvited(_: IRegisterInvitedProps) {
  const [loading, setLoading] = useState<boolean>(false);
  const makeRequest = useApiCallHandling();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email")
    ? decodeURIComponent(searchParams.get("email")!)
    : null;

  const navigate = useNavigate();
  const notify = useNotification();

  function processFormInputs(formData: KeyValueObj) {
    setLoading(true);
    makeRequest(
      COMPLETE_DRF_INVITATION_URL,
      "POST",
      formData,
      () => {
        navigate("/login");
      },
      (error) => {
        if (error.response.data.message) {
          notify({
            type: "ERROR",
            message: error.response.data.message || "Something went wrong",
          });
        }
      },
      () => {
        setLoading(false);
      },
      {
        dontNotifyonFail: true,
      }
    );
  }

  return (
    <InvitedWrapper>
      <div className="top flex-row">
        <div className="welcome-message">
          <h2 className="sign-up">Sign Up</h2>
        </div>
      </div>
      <div className="form">
        <Form
          formInputs={registerInvitedInput(email || "")}
          loadingState={loading}
          submitLabel="Sign Up"
          processInputs={processFormInputs}
          spinnerComponent={<ClipSpinner />}
          login={false}
          biControl={false}
          handleBack={undefined}
        />
      </div>
    </InvitedWrapper>
  );
}
